import BCheckpanel from "./BCheckpanel";

export default class BCheckpanelCollection
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.b-checkpanel-collection`;

	getItems()
	{
		let res = [];
		this.el.querySelectorAll(`${BCheckpanel.selector()}`).forEach(el => {
			res.push(new BCheckpanel(el));
		});

		return res;
	}
}
